import { tap } from 'rxjs/operators';
import { cpvAuthAPI } from '@/api/cpv/cpv.auth.api';

const api = new cpvAuthAPI();

export class CpvAuthService {
  login(cpf: string, secret: string) {
    return api.login(cpf, secret).pipe(
      tap((response: any) => {
        localStorage.setItem('cpv_token', response.token);
      })
    );
  }
}
